// AdminHiringContent.js
/*
import React, { useState, useEffect } from 'react';
import { storage } from './firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

const API_URL = `${process.env.REACT_APP_API_URL}/api/hiring-documents`;

function AdminHiringContent() {
  const [doc, setDoc] = useState({ notes: [] });
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [editingNote, setEditingNote] = useState(null);
  const [noteForm, setNoteForm] = useState({ orderNumber: 1, noteTitle: '', noteBody: '' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await fetch(API_URL);
      const json = await res.json();
      if (res.ok) setDoc(json.data || { notes: [] });
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)) {
      setMessage('❌ Only PDF, DOC, DOCX');
      return;
    }
    setUploading(true);
    try {
      const fileRef = ref(storage, `hiring-docs/${Date.now()}_${file.name}`);
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);
      await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileName: file.name, fileURL: url, fileType: file.type })
      });
      setMessage('✅ Uploaded!');
      fetchData();
    } catch (err) { setMessage('❌ Failed'); }
    finally { setUploading(false); }
  };

  const deleteDoc = async () => {
  if (!window.confirm('Delete document?')) return; // ✅ fixed
  try {
    if (doc.fileURL) await deleteObject(ref(storage, doc.fileURL));
    await fetch(API_URL, { method: 'DELETE' });
    setMessage('✅ Deleted');
    fetchData();
  } catch (err) { setMessage('❌ Failed'); }
};

  const openNoteModal = (note = null) => {
    if (note) {
      setEditingNote(note);
      setNoteForm({ orderNumber: note.orderNumber, noteTitle: note.noteTitle, noteBody: note.noteBody });
    } else {
      setEditingNote(null);
      setNoteForm({ orderNumber: doc.notes.length ? Math.max(...doc.notes.map(n => n.orderNumber)) + 1 : 1, noteTitle: '', noteBody: '' });
    }
    setShowNoteModal(true);
  };

  const saveNote = async (e) => {
    e.preventDefault();
    const url = editingNote ? `${API_URL}/notes/${editingNote._id}` : `${API_URL}/notes`;
    const method = editingNote ? 'PUT' : 'POST';
    try {
      await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(noteForm) });
      setMessage('✅ Note saved');
      setShowNoteModal(false);
      fetchData();
    } catch (err) { setMessage('❌ Failed'); }
  };

  const deleteNote = async (id) => {
  if (!window.confirm('Delete note?')) return; // ✅ fixed
  await fetch(`${API_URL}/notes/${id}`, { method: 'DELETE' });
  setMessage('✅ Deleted');
  fetchData();
};

  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>;

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa', padding: '2rem' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <h1 style={{ textAlign: 'center', fontSize: '2.8rem', marginBottom: '2rem' }}>
          Hiring <span style={{ color: '#2c5282' }}>Agreement & Notes</span>
        </h1>

        {message && <div style={{ padding: '1rem', background: message.startsWith('✅') ? '#d4edda' : '#f8d7da', color: message.startsWith('✅') ? '#155724' : '#721c24', borderRadius: '8px', textAlign: 'center', marginBottom: '2rem' }}>{message}</div>}

        <div style={{ background: 'white', borderRadius: '16px', padding: '2rem', boxShadow: '0 8px 25px rgba(0,0,0,0.08)', marginBottom: '3rem' }}>
          <h2>📄 Agreement Document</h2>
          {doc.fileURL ? (
            <div style={{ padding: '1.5rem', background: '#f8f9fa', borderRadius: '12px' }}>
              <p><strong>{doc.fileName}</strong> (Uploaded: {new Date(doc.updatedAt).toLocaleDateString()})</p>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <a href={doc.fileURL} target="_blank" rel="noopener noreferrer" style={{ flex: 1, padding: '1rem', background: '#2c5282', color: 'white', textAlign: 'center', borderRadius: '8px' }}>View</a>
                <button onClick={deleteDoc} style={{ flex: 1, padding: '1rem', background: '#e53e3e', color: 'white', borderRadius: '8px' }}>Delete</button>
              </div>
            </div>
          ) : <p style={{ color: '#888', textAlign: 'center', padding: '2rem' }}>No document uploaded</p>}

          <label style={{ display: 'block', marginTop: '2rem', padding: '2rem', border: '2px dashed #2c5282', borderRadius: '12px', textAlign: 'center', cursor: 'pointer' }}>
            <input type="file" accept=".pdf,.doc,.docx" onChange={handleUpload} disabled={uploading} style={{ display: 'none' }} />
            <div style={{ fontSize: '3rem' }}>{uploading ? '⏳' : '📁'}</div>
            <div style={{ fontWeight: '600', color: '#2c5282' }}>{uploading ? 'Uploading...' : 'Upload Document'}</div>
          </label>
        </div>

        <div style={{ background: 'white', borderRadius: '16px', padding: '2rem', boxShadow: '0 8px 25px rgba(0,0,0,0.08)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
            <h2>📝 Customer Notes</h2>
            <button onClick={() => openNoteModal()} style={{ padding: '0.8rem 1.5rem', background: '#2c5282', color: 'white', borderRadius: '8px' }}>Add Note</button>
          </div>

          {doc.notes.length > 0 ? doc.notes.map(note => (
            <div key={note._id} style={{ border: '1px solid #eee', borderRadius: '12px', padding: '1.5rem', marginBottom: '1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <strong>{note.orderNumber}. {note.noteTitle}</strong>
                  <p style={{ margin: '0.5rem 0' }}>{note.noteBody}</p>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <button onClick={() => openNoteModal(note)} style={{ padding: '0.5rem 1rem', background: '#3182ce', color: 'white', borderRadius: '6px' }}>Edit</button>
                  <button onClick={() => deleteNote(note._id)} style={{ padding: '0.5rem 1rem', background: '#e53e3e', color: 'white', borderRadius: '6px' }}>Delete</button>
                </div>
              </div>
            </div>
          )) : <p style={{ textAlign: 'center', color: '#888' }}>No notes yet</p>}
        </div>

        {showNoteModal && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
            <div style={{ background: 'white', padding: '2rem', borderRadius: '16px', width: '90%', maxWidth: '600px' }}>
              <h3>{editingNote ? 'Edit' : 'Add'} Note</h3>
              <form onSubmit={saveNote}>
                <input type="number" placeholder="Order" value={noteForm.orderNumber} onChange={e => setNoteForm({...noteForm, orderNumber: +e.target.value})} style={{ width: '100%', padding: '0.8rem', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd' }} required />
                <input type="text" placeholder="Title" value={noteForm.noteTitle} onChange={e => setNoteForm({...noteForm, noteTitle: e.target.value})} style={{ width: '100%', padding: '0.8rem', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd' }} required />
                <textarea placeholder="Content" rows="5" value={noteForm.noteBody} onChange={e => setNoteForm({...noteForm, noteBody: e.target.value})} style={{ width: '100%', padding: '0.8rem', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd' }} required />
                <div style={{ display: 'flex', gap: '1rem' }}>
                  <button type="submit" style={{ flex: 1, padding: '1rem', background: '#2c5282', color: 'white', borderRadius: '8px' }}>Save</button>
                  <button type="button" onClick={() => setShowNoteModal(false)} style={{ flex: 1, padding: '1rem', background: '#777', color: 'white', borderRadius: '8px' }}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminHiringContent;*/
// AdminHiringContent.js
import React, { useState, useEffect } from 'react';
import { storage } from './firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

// Proxy-relative in dev, full URL in production
const HIRING_DOCS_API = process.env.NODE_ENV === 'production'
  ? `${process.env.REACT_APP_API_URL}/api/hiring-documents`  // ← your real backend
  : '/api/hiring-documents';

function AdminHiringContent() {
  const [doc, setDoc] = useState({ notes: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Added missing error state
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [editingNote, setEditingNote] = useState(null);
  const [noteForm, setNoteForm] = useState({ orderNumber: 1, noteTitle: '', noteBody: '' });

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    try {
      const res = await fetch(HIRING_DOCS_API, {
        signal: controller.signal,
        headers: {
          'Accept': 'application/json',
          'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
        },
        credentials: 'same-origin',
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        if (res.status === 401) throw new Error('Unauthorized - check API key');
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const json = await res.json();
      if (json.success && json.data) {
        setDoc(json.data);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setError(err.message || 'Failed to load hiring content');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchData();

    return () => {
    };
  }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)) {
      setMessage('❌ Only PDF, DOC, DOCX allowed');
      return;
    }

    setUploading(true);
    setMessage('');

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000); // longer for upload

    try {
      const fileRef = ref(storage, `hiring-docs/${Date.now()}_${file.name}`);
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);

      const res = await fetch(HIRING_DOCS_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
        },
        body: JSON.stringify({ fileName: file.name, fileURL: url, fileType: file.type }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!res.ok) throw new Error('Failed to save document metadata');

      setMessage('✅ Document uploaded successfully!');
      fetchData();
    } catch (err) {
      console.error('Upload failed:', err);
      setMessage('❌ Upload failed: ' + (err.message || 'Unknown error'));
    } finally {
      setUploading(false);
    }
  };

  const deleteDoc = async () => {
    if (!window.confirm('Are you sure you want to delete the agreement document?')) return;

    setUploading(true); // reuse for loading state
    setMessage('');

    try {
      if (doc.fileURL) {
        await deleteObject(ref(storage, doc.fileURL)).catch(err => {
          if (err.code !== 'storage/object-not-found') throw err;
        });
      }

      const res = await fetch(HIRING_DOCS_API, {
        method: 'DELETE',
        headers: {
          'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
        },
      });

      if (!res.ok) throw new Error('Failed to delete document');

      setMessage('✅ Document deleted');
      fetchData();
    } catch (err) {
      console.error('Delete failed:', err);
      setMessage('❌ Failed to delete: ' + (err.message || 'Unknown error'));
    } finally {
      setUploading(false);
    }
  };

  const openNoteModal = (note = null) => {
    if (note) {
      setEditingNote(note);
      setNoteForm({
        orderNumber: note.orderNumber,
        noteTitle: note.noteTitle,
        noteBody: note.noteBody
      });
    } else {
      setEditingNote(null);
      setNoteForm({
        orderNumber: doc.notes.length ? Math.max(...doc.notes.map(n => n.orderNumber)) + 1 : 1,
        noteTitle: '',
        noteBody: ''
      });
    }
    setShowNoteModal(true);
  };

  const saveNote = async (e) => {
    e.preventDefault();
    setMessage('');

    const url = editingNote
      ? `${HIRING_DOCS_API}/notes/${editingNote._id}`
      : `${HIRING_DOCS_API}/notes`;
    const method = editingNote ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
        },
        body: JSON.stringify(noteForm),
      });

      if (!res.ok) throw new Error('Failed to save note');

      setMessage('✅ Note saved successfully!');
      setShowNoteModal(false);
      fetchData();
    } catch (err) {
      console.error('Note save failed:', err);
      setMessage('❌ Failed to save note: ' + (err.message || 'Unknown error'));
    }
  };

  const deleteNote = async (id) => {
    if (!window.confirm('Are you sure you want to delete this note?')) return;

    try {
      const res = await fetch(`${HIRING_DOCS_API}/notes/${id}`, {
        method: 'DELETE',
        headers: {
          'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
        },
      });

      if (!res.ok) throw new Error('Failed to delete note');

      setMessage('✅ Note deleted');
      fetchData();
    } catch (err) {
      console.error('Note delete failed:', err);
      setMessage('❌ Failed to delete note: ' + (err.message || 'Unknown error'));
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8f9fa',
        fontSize: '1.8rem',
        color: '#333'
      }}>
        Loading content...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8f9fa',
        color: '#dc3545',
        textAlign: 'center',
        padding: '2rem'
      }}>
        <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Error Loading Content</h2>
        <p style={{ fontSize: '1.3rem', maxWidth: '600px' }}>{error}</p>
        <button
          onClick={fetchData}
          style={{
            marginTop: '2rem',
            padding: '1rem 2.5rem',
            background: '#2c5282',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1.1rem',
            cursor: 'pointer'
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa', padding: '2rem' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <h1 style={{ textAlign: 'center', fontSize: '2.8rem', marginBottom: '2rem' }}>
          Hiring <span style={{ color: '#2c5282' }}>Agreement & Notes</span>
        </h1>

        {message && (
          <div style={{
            padding: '1rem',
            background: message.startsWith('✅') ? '#d4edda' : '#f8d7da',
            color: message.startsWith('✅') ? '#155724' : '#721c24',
            borderRadius: '8px',
            textAlign: 'center',
            marginBottom: '2rem'
          }}>
            {message}
          </div>
        )}

        {/* Document Section */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '2rem',
          boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
          marginBottom: '3rem'
        }}>
          <h2>📄 Agreement Document</h2>
          {doc.fileURL ? (
            <div style={{ padding: '1.5rem', background: '#f8f9fa', borderRadius: '12px' }}>
              <p><strong>{doc.fileName}</strong> (Uploaded: {new Date(doc.updatedAt).toLocaleDateString()})</p>
              <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                <a
                  href={doc.fileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    flex: 1,
                    padding: '1rem',
                    background: '#2c5282',
                    color: 'white',
                    textAlign: 'center',
                    borderRadius: '8px',
                    textDecoration: 'none'
                  }}
                >
                  View Document
                </a>
                <button
                  onClick={deleteDoc}
                  disabled={uploading}
                  style={{
                    flex: 1,
                    padding: '1rem',
                    background: uploading ? '#ccc' : '#e53e3e',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: uploading ? 'not-allowed' : 'pointer'
                  }}
                >
                  {uploading ? 'Processing...' : 'Delete'}
                </button>
              </div>
            </div>
          ) : (
            <p style={{ color: '#888', textAlign: 'center', padding: '2rem' }}>No document uploaded yet</p>
          )}

          <label style={{
            display: 'block',
            marginTop: '2rem',
            padding: '2rem',
            border: '2px dashed #2c5282',
            borderRadius: '12px',
            textAlign: 'center',
            cursor: uploading ? 'not-allowed' : 'pointer',
            opacity: uploading ? 0.6 : 1
          }}>
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleUpload}
              disabled={uploading}
              style={{ display: 'none' }}
            />
            <div style={{ fontSize: '3rem' }}>{uploading ? '⏳' : '📁'}</div>
            <div style={{ fontWeight: '600', color: '#2c5282' }}>
              {uploading ? 'Uploading...' : 'Upload New Document (PDF/DOC/DOCX)'}
            </div>
          </label>
        </div>

        {/* Notes Section */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '2rem',
          boxShadow: '0 8px 25px rgba(0,0,0,0.08)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
            <h2>📝 Customer Notes</h2>
            <button
              onClick={() => openNoteModal()}
              style={{
                padding: '0.8rem 1.5rem',
                background: '#2c5282',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              Add Note
            </button>
          </div>

          {doc.notes.length > 0 ? (
            doc.notes.map(note => (
              <div key={note._id} style={{
                border: '1px solid #eee',
                borderRadius: '12px',
                padding: '1.5rem',
                marginBottom: '1rem',
                background: '#f8f9fa'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <strong>{note.orderNumber}. {note.noteTitle}</strong>
                    <p style={{ margin: '0.5rem 0', whiteSpace: 'pre-wrap' }}>{note.noteBody}</p>
                  </div>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button
                      onClick={() => openNoteModal(note)}
                      style={{
                        padding: '0.5rem 1rem',
                        background: '#3182ce',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer'
                      }}
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => deleteNote(note._id)}
                      style={{
                        padding: '0.5rem 1rem',
                        background: '#e53e3e',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer'
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p style={{ textAlign: 'center', color: '#888', padding: '2rem' }}>No notes added yet</p>
          )}
        </div>

        {/* Note Modal */}
        {showNoteModal && (
          <div style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}>
            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '16px',
              width: '90%',
              maxWidth: '600px'
            }}>
              <h3 style={{ marginBottom: '1.5rem', color: '#2c5282' }}>
                {editingNote ? 'Edit Note' : 'Add New Note'}
              </h3>
              <form onSubmit={saveNote}>
                <input
                  type="number"
                  placeholder="Order Number"
                  value={noteForm.orderNumber}
                  onChange={e => setNoteForm({ ...noteForm, orderNumber: +e.target.value })}
                  style={{ width: '100%', padding: '0.8rem', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd' }}
                  required
                />
                <input
                  type="text"
                  placeholder="Note Title"
                  value={noteForm.noteTitle}
                  onChange={e => setNoteForm({ ...noteForm, noteTitle: e.target.value })}
                  style={{ width: '100%', padding: '0.8rem', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd' }}
                  required
                />
                <textarea
                  placeholder="Note Content"
                  rows="5"
                  value={noteForm.noteBody}
                  onChange={e => setNoteForm({ ...noteForm, noteBody: e.target.value })}
                  style={{ width: '100%', padding: '0.8rem', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd' }}
                  required
                />
                <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
                  <button
                    type="submit"
                    style={{
                      flex: 1,
                      padding: '1rem',
                      background: '#2c5282',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer'
                    }}
                  >
                    Save Note
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowNoteModal(false)}
                    style={{
                      flex: 1,
                      padding: '1rem',
                      background: '#777',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer'
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminHiringContent;